import { useLanguage } from '../i18n/content';

export function LangSwitch({ testIdPrefix = 'lang', className = '' }) {
  const { lang, setLang } = useLanguage();
  const btn = (code) =>
    `font-mono text-xs font-semibold tracking-widest transition-colors duration-300 ${
      lang === code ? 'text-nofina-red' : 'text-slate-400 hover:text-white'
    }`;
  return (
    <div
      data-testid={`${testIdPrefix}-switcher`}
      className={`flex items-center gap-2 ${className}`}
    >
      <button
        type="button"
        data-testid={`${testIdPrefix}-id`}
        className={btn('id')}
        onClick={() => setLang('id')}
        aria-pressed={lang === 'id'}
      >
        ID
      </button>
      <span className="text-white/25">|</span>
      <button
        type="button"
        data-testid={`${testIdPrefix}-en`}
        className={btn('en')}
        onClick={() => setLang('en')}
        aria-pressed={lang === 'en'}
      >
        EN
      </button>
    </div>
  );
}
